import { render } from "./UploadVirtualFace.vue?vue&type=template&id=5538a474&scoped=true&ts=true"
import script from "./UploadVirtualFace.vue?vue&type=script&lang=ts"
export * from "./UploadVirtualFace.vue?vue&type=script&lang=ts"

import "./UploadVirtualFace.vue?vue&type=style&index=0&id=5538a474&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src129899678/src/web-ext-ai-voucher-humelo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5538a474"]])

export default __exports__